import { render, staticRenderFns } from "./AssignmentData.vue?vue&type=template&id=14232cb0&scoped=true&"
import script from "./AssignmentData.vue?vue&type=script&lang=js&"
export * from "./AssignmentData.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentData.vue?vue&type=style&index=0&id=14232cb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14232cb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDivider,VIcon})
